<div class="order-status-header">
  <div class="order-status-description">
    <h3 class="order-status-title">
      {{ "ordersHistory.status.title" | translate }}
    </h3>
    <p class="order-status-subtitle">
      {{
        "ordersHistory.status.subtitle"
          | translate: { status: status()?.toLowerCase() || "" }
      }}
    </p>
  </div>
  @if (currentStatus() === "cancelled") {
    <ng-container [ngTemplateOutlet]="cancelledMessage"></ng-container>
  }
</div>

<ul [class]="'order-status-list ' + currentStatus()">
  @for (step of steps(); track $index) {
    <li class="order-status-item">
      @if (!$first) {
        <div class="order-status-connector"></div>
      }

      <fu-icon
        class="order-status-icon"
        [iconName]="'os-' + step"
        [size]="isDesktop() ? 12 : 16"
      />
    </li>
  }
</ul>

<ng-template #cancelledMessage>
  <div class="order-status-message">
    <h3 class="order-status-title">
      {{ "ordersHistory.status.cancelled.message" | translate }}
    </h3>
    <p class="order-status-subtitle">
      <fu-icon iconName="account" size="16" />
      {{ "account.name" | translate: { currency: currency()?.symbol } }}
    </p>
  </div>
</ng-template>
